import React from 'react';
import {DayTimePicker} from '../../../ui-toolkit/indexExportV2';

function DateTimeEditor({fieldName}) {
    return <DayTimePicker name={fieldName} />;
}

export default DateTimeEditor;
